export const environment = {
  production: false,
  JAVA_BASE_URL: 'https://dev-services.taxplaniq.com',
  DOCUMENT_SERVICE_URL: 'https://dev-docs.taxplaniq.com/DocumentServices',
  froalaKey: 'SDB17hC7B6C5G4H4G4F3c1JWSDBCQJ1ZGDa1F1c1JXDAAOZWJhB3D3C10B5C3C4B4F3E3H3==',
  KNOLLI_CHAT_URL: 'https://stag-knolli.taxplaniq.com',
  questionnaireAiAssistantId: 1523,
  jaineAiAssistantId: 1511,
  features: {
    enableQuestionnarieInRap: true,
    // Phase 1a — master switch for the post-login choose-platform interstitial
    // + Tax Projections handoff. When false, login routes straight to
    // /tpiq/dashboard for everyone. When true, eligible users (Growth tier,
    // or any user when taxProjectionsBypassTier is on) see /choose-platform.
    enableTaxProjections: true,
    // QA override — when true, the Growth-tier check in login.component.ts
    // is skipped so any dev user reaches /choose-platform. Defaults off.
    taxProjectionsBypassTier: false,
    // Per-firm tenant allowlist REMOVED at GA (2026-06-02): Tax Projections
    // is open to all Growth-tier firms.
    enableReportingV2: true,
    enableInvestmentFeature : true
  }
}
